import { CaretRight } from "@phosphor-icons/react";
import clsx from "clsx";

import RelativeLink from "common/components/RelativeLink";
import Checkbox from "common/components/ui/Checkbox";

import type { JSX, ReactNode } from "react";

type MobileListItemProps = {
  isSelected: boolean;
  toggleIsSelected: () => void;
  isSelecting: boolean;
  badgeContent: JSX.Element[];
  children: ReactNode;
} & (
  | { onClick: () => void; relativeTo?: never }
  | { onClick?: never; relativeTo: string }
  | { onClick?: never; relativeTo?: never }
);

export default function MobileSelectionListItem({
  toggleIsSelected,
  isSelected,
  isSelecting,
  children,
  badgeContent,
  relativeTo,
  onClick,
}: MobileListItemProps) {
  const wrapperStyles = clsx(
    "flex gap-x-1.5 p-2",
    isSelected && "bg-purple-50 rounded-2xl",
  );

  const content = (
    <>
      <div className="flex flex-col gap-y-1.5 w-full flex-1">
        <div className="flex items-center gap-x-1.5">
          {isSelecting && <Checkbox isStyleOnly checked={isSelected} />}
          {children}
          {!isSelecting && (onClick || relativeTo) && (
            <CaretRight className="size-4 ml-auto" />
          )}
        </div>

        {/* Tags */}
        <div className="flex ml-9 gap-1.5 mt-1.5 flex-wrap empty:hidden">
          {badgeContent}
        </div>
      </div>
    </>
  );

  if (isSelecting || !relativeTo) {
    return (
      <button
        type="button"
        className={wrapperStyles}
        onClick={(e) => {
          if (isSelecting) {
            toggleIsSelected();
          } else {
            const target = e.target as HTMLElement;

            if (target.closest("button, a") === e.currentTarget) {
              onClick?.();
            }
          }
        }}
      >
        {content}
      </button>
    );
  }

  return (
    <RelativeLink className={wrapperStyles} to={relativeTo}>
      {content}
    </RelativeLink>
  );
}
